export default __webpack_public_path__ + "static/media/detailsCar.6b8b3a6b.png";